































import UiFiltersAndActions from '@/components/Ui/FiltersAndActions/FiltersAndActions.vue'
import SelectField, {SelectFieldOptions} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'
import Vue from 'vue'
import wikiTree from '@/components/wiki/tree.vue'
import {USER_ROLE_WIKI} from '@/constants'
export default Vue.extend({
  components: {
    UiFiltersAndActions,
    wikiTree
  },
  data () {
    return {
      tree: []
    }
  },
  methods: {
    search () {},
  },
  computed: {
    admin () {
      return this.$store.state.user.user.checkRole(USER_ROLE_WIKI)
    }
  }
})
